'use strict';

var _ = require('underscore');
var Backbone = require('js/lib/sw-backbone');
var sw = require('js/lib/sw');
var swUtils = require('js/lib/sw-utils');
var notifications = require('js/lib/notifications/sw-notifications');
var tryAgainTemplate = require('rrTags/notifications/templates/tpl.add-to-cart-try-again.mustache');
var genericErrorTemplate = require('rrTags/notifications/templates/tpl.add-to-cart-generic-error.mustache');
var cartMaxedErrorTemplate = require('rrTags/cart/templates/tpl.add-to-cart-cart-maxed-error.mustache');

var SW_AJAX_DEFAULT_ID_NAMESPACE = 'timoutId_';

var SW_TIMEOUT_TIME = 10000;

var SW_CALLBACK_SUFFIX = 'Cb';
var SW_RETRY_CALLBACK_PREFIX = 'retry';

var SW_AJAX_RETRY_EVENT = 'swAjaxRetry';

var ERROR_TYPES = {
	ALL: 'all',
	ABORT: 'abort',
	PARSE_ERROR: 'parsererror',
	TIMEOUT: 'timeout',
  ERROR: 'error'
};

var FLASH_MESSAGES_PARAM = 'flashMessages';

/**
 * Makes the default notey with retry link
 * 
 * @param  {string} 	eventID 	the event to trigger a retry
 */
function triggerDefaultRetryNotey(eventID) {
	notifications.error(tryAgainTemplate.render({ eventID: eventID }), {
    closeWith: ['button']
  });
}

/**
 * Makes the default notey with retry link
 * 
 * @param  {string} 	eventID 	the event to trigger a retry
 */
function triggerDefaultFailNotey() {
	notifications.error(genericErrorTemplate.render());
}

/**
 *  notey for cart maxed error
 */
function triggerCartMaxedNotey() {
	notifications.error(cartMaxedErrorTemplate.render());
}

/**
 * Makes the default notey with message
 * 
 * @param  {string} message
 */
function triggerErrorNotey(message) {
	notifications.error(message);
}


/**
 * Checks texts status against retryOnType to see if we care bout the textStatus
 * 
 * @param  {string|Array} 	retryOnType  		string or array of types to retry on
 * @param  {string} 		 		textStatus 			error type
 * @return {boolean}            						if text status is in retryType
 */
function shouldListenForEvent(retryOnType, textStatus) {

	// If swRetryOn is an array search for the status in the array
	if(_.isArray(retryOnType)) {
		return ((retryOnType.indexOf(textStatus) > -1) || (retryOnType.indexOf(ERROR_TYPES.ALL) > -1));
	}

	// If it's type ALL or matches the textStatus specifically
	return (retryOnType === ERROR_TYPES.ALL || retryOnType === textStatus);
}

/**
 * take a sting and formats it into a retry callback name
 *
 *  -- memoized for long term perf win
 * 
 * @param  {string} 	string 		string to be formatted
 * @return {string}            	formatted string
 */
var makeRetryCallbackName = _.memoize(function makeRetryCallbackName(string) {
	return SW_RETRY_CALLBACK_PREFIX + swUtils.capitalizeFirst(string);
});

/**
 * chacks if object has retry callback for error types
 * 
 * @param  {object}  settings  	object with possible callbacks
 * @return {Boolean}          	boolean of if callback exists
 */
function checkHasRetryCallback(settings) {
	var key;

	for (key in ERROR_TYPES) {
		if (ERROR_TYPES.hasOwnProperty(key) && _.isFunction(settings[makeRetryCallbackName(ERROR_TYPES[key])])) {
			return true;
		}
	}

	return false;
}

module.exports = function($) {

	/**
	 * Meta function to build an unregister function
	 * 
	 * @param  {string} 		eventID 	eventID to later unregister 
	 * @return {function}         		unregiser function to unregister eventID
	 */
	function unregisterFuncBuilder(eventID) {
		return function unregisterEvent() {
			$.swAjax.stopListening(sw, eventID);
		};
	}

	/**
	 * Makes it so we can opt into creating a retry event
	 * 
	 * @param  {object} self     context of swAjax
	 * @param  {object} settings settings supplied to swAjax
	 * @return {object}          object with the retry info and new callbacks
	 */
	function buildRetryInfo(self, settings) {
		var retryInfo = {
			error: function(){},
			success: function(){}
		};

		var retryEventID = settings.retryEventID;

		// If theres not a retry event or a retryCallback 
		if(!retryEventID && !checkHasRetryCallback(settings)) {
			return retryInfo;
		}

		var retryOnType = _.clone(settings.retryOnType);

		// If retryEventID isn't a string make a unique event name 
		if(!_.isString(retryEventID)) {
			retryEventID = SW_AJAX_RETRY_EVENT + ':' + _.uniqueId(SW_AJAX_DEFAULT_ID_NAMESPACE);
		}

		// easy way to keep unregistration consistent
		var unregisterRetryEvent = unregisterFuncBuilder(retryEventID);

		$.swAjax.listenToOnce(sw, retryEventID, function swAjaxRetryFn() {

			// This event should only ever fire once
			unregisterRetryEvent();

			// Try the call again
			$.swAjax.call(self, _.extend({}, settings));

		});

		return {
			// Make unregister event function
			unregisterRetryEvent: unregisterRetryEvent,

			// Event to be triggered
			retryEventID: retryEventID,
			
			// Remove the event listener
			success: function success() {
				unregisterRetryEvent();
			},

			// Remove the event listener if we don't care about retrying for that type 
			error: function error(jqXHR, textStatus, errorThrown, swInfo) {
				var retryFn = settings[makeRetryCallbackName(textStatus)];
				var hasCb = _.isFunction(retryFn);

				// Listen for retry if it's been flagged or we have a retry callback
				swInfo.canRetry = shouldListenForEvent(retryOnType, textStatus) || hasCb;

				// if we shouldn't listen then stop
				if(!swInfo.canRetry) {
					unregisterRetryEvent();
					return;
				} 

				// If we have a cb call it
				if(hasCb) {
					retryFn(jqXHR, textStatus, errorThrown, swInfo);
				}

			}

		};
	}

	/**
	 * Makes it so we can supply specific callbacks for the different error text statuses
	 * 
	 * @param  {object} self     context of swAjax
	 * @param  {object} settings settings supplied to swAjax
	 * @return {object}          objerct with new error function functionality
	 */
	function buildErrorTextStatusCallback(self, settings) {
		return {

			// Check for specific textStatus callback type and call it if it exists
			error: function error(jqXHR, textStatus, errorThrown, swInfo) {
				var textStatusFunc = settings[textStatus + SW_CALLBACK_SUFFIX];

				// If we have a callback for our text status call it 
				if(_.isFunction(textStatusFunc)) {
					textStatusFunc(jqXHR, textStatus, errorThrown, swInfo);
				}
			}
		};
	}

	/**
	 * Wrapper around normal jquery.ajax which lets us trigger a notification on timeout.
	 * 
	 * @param  {string | object} 			url      													url string or settings object
	 * @param  {object | undefined} 	settings 													object or undefined if url is an object                                
	 * @param  {string} 							settings.retryEventID						  flag or eventnamespace to use for retry event
	 * @param  {string | Array} 			settings.retryOnType = 'ALL'			error type(s) to respond to
	 * @param  {function} 						settings[textStatus + Cb]					text status specific callbacks
	 * @param  {function} 						settings[retry + TextStatus]			retry specific callbacks
	 */
  $.swAjax = function swAjax(url, settings) {

  	// Support passing in object as first argument or url string and then options
  	settings = _.isString(url) && !_.isObject(settings) ? {} : settings;
  	settings = _.isUndefined(settings) ? url : (settings.url = url);

  	// set swAjax defaults
		settings = _.defaults(settings, {

			// Boolean or namespace for retry event
			retryEventID: undefined,

			// Retry all by default
			retryOnType: ERROR_TYPES.ALL,

			// In case no callbacks are supplied we don't have to check for functions later
			complete: function(){},
			error: function() {},
			success: function() {}

		});

		// Keep context
		var self = this;

		// Setup functionality for retrying
		var retryInfo = buildRetryInfo(self, settings);

		// Setup functionality for supporting textStatus specific callbacks
		var errorTextStatusInfo = buildErrorTextStatusCallback(self, settings);

		// The extra info we want to supply to swAjax Callbacks
		var swInfo = {
			settings: settings,
			canRetry: retryInfo.canRetry,
			retryEventID: retryInfo.retryEventID,
			unregisterRetryEvent: retryInfo.unregisterRetryEvent
		};

		// Make the callbacks that actually go to $.ajax
		var settingsClone = _.extend({}, settings, {

			// Call all new functionality we want from errors
			error: function error(jqXHR, textStatus, errorThrown) {
				retryInfo.error(jqXHR, textStatus, errorThrown, swInfo);
				errorTextStatusInfo.error(jqXHR, textStatus, errorThrown, swInfo);
				settings.error(jqXHR, textStatus, errorThrown, swInfo);
			},

			// Call all new functionality we want from success
			success: function success(data, textStatus, jqXHR) {
				retryInfo.success(data, textStatus, jqXHR, swInfo);
				settings.success(data, textStatus, jqXHR, swInfo);
			},

			// Call anything that should happen on all requests
			complete: function complete(data, textStatus) {
				var response;
				var $flashMessages;

				try {
					response = JSON.parse(data.responseText);
				} catch(e) {
					response = data;
				}

				if(response[FLASH_MESSAGES_PARAM]) {
					$flashMessages = $(response[FLASH_MESSAGES_PARAM]);
					sw.trigger('sw-fragment-loaded', $flashMessages);
				}
				settings.complete(data, textStatus);
			}
		});
		// Trigger the AJAX
		return $.ajax(settingsClone);
  };



  // give $.swAjax event powers
 	_.extend($.swAjax, Backbone.Events);

  // Expose try again template
  $.swAjax.tryAgainTemplate = tryAgainTemplate;

  // Expose trigger default retry notey
  $.swAjax.triggerDefaultRetryNotey = triggerDefaultRetryNotey;

  // Expose trigger default error notey
  $.swAjax.triggerDefaultFailNotey = triggerDefaultFailNotey;

  $.swAjax.triggerCartMaxedNotey = triggerCartMaxedNotey;

  // Expose trigger error notey
  $.swAjax.triggerErrorNotey = triggerErrorNotey;

  // Expose timeout time
  $.swAjax.SW_TIMEOUT_TIME = SW_TIMEOUT_TIME;

  // Expose error types 
  $.swAjax.ERROR_TYPES = ERROR_TYPES;

  // Expose retry event namespace
  $.swAjax.SW_AJAX_RETRY_EVENT = SW_AJAX_RETRY_EVENT;

};
